// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// import aif1 from "../../assets/aif-1.jpg";
// import aif2 from "../../assets/aif-2.jpg";
// import aif3 from "../../assets/aif-3.jpg";

// export default function AIF() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Agriculture Infrastructure Fund (AIF) from MOA</h1>
//                                   <p>Indian Government has recently launched a new Scheme of financing facility under the Agriculture Infrastructure Fund (AIF) of Rs. 1 Lakh Crore. The Agriculture Infrastructure Fund is a medium – long term debt financing facility for investment in projects for post-harvest management infrastructure and community farming assets through interest subvention and credit guarantee. The scheme will support Agri-entrepreneurs, Farmer Producer Organization (FPO), and Primary Agricultural Credit Society (PACS). Under the scheme, bank and the financial institution will provide Rs. 1 Lakh Crore as loans with interest subvention of 3% per annum and credit guarantee coverage under CGTMSE scheme for loans up to Rs. 2 Crore. The present article briefs the Agriculture Infrastructure Fund (AIF) scheme.</p>

//                                   <h2>Objectives of Agriculture Infrastructure Fund</h2>
//                                   <p>The key objective of the Agriculture Infrastructure Fund (AIF) is to provide financial support for agriculture entrepreneurs to improve agriculture infrastructure in the country.</p>
//                                   </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Benefits of the Agriculture Infrastructure Fund (AIF)</h2>
//                                   <p>The beneficiaries of the Agriculture Infrastructure Fund (AIF) scheme will include:</p>

//                                   <ul>
//                                       <li>Farmers</li>
//                                       <li>SHG – a self-help group</li>
//                                       <li>Agri-entrepreneurs</li>
//                                       <li>Startups</li>
//                                       <li>Primary Agricultural Credit Society (PACS)</li>
//                                       <li>Marketing Cooperative Societies</li>
//                                       <li>Farmer Producer Organization (FPO</li>
//                                       <li>Joint Liability Groups (JLG)</li>
//                                       <li>Multipurpose Cooperative Societies</li>
//                                       <li>Central/State agency or local Body sponsored Public-Private Partnership Projects</li>
//                                   </ul>

//                                   <h2>Benefits of Agriculture Infrastructure Fund</h2>
//                                   <p>This financing facility will have numerous benefits for all the stakeholders in the agriculture eco-system:</p>
//                                   <p>Benefits to Farmers FPOs, PACS & Marketing Cooperative Societies</p>

//                                   <ul>
//                                       <li>AIF will improve the overall income of farmers</li>
//                                       <li>The Improved marketing infrastructure will farmers to sell directly to a larger base of consumers and hence, increase value realization for the farmers</li>
//                                       <li>AIF will make farmers independent and improve access to market</li>
//                                       <li>Farmers can be able to decide when to sell in the market and improve realization using the modern packaging and cold storage system access.</li>
//                                       <li>Benefits to Agri entrepreneurs and start-ups</li>
//                                       <li>With a dedicated source of funding, entrepreneurs will push for innovation in the agriculture sector by leveraging new-age technologies including IoT (internet of things), AI (artificial intelligence), etc.</li>
//                                       <li>AIF will improve avenues for collaboration between entrepreneurs and farmers.</li>
//                                   </ul>

//                                   <h2>Duration of the scheme</h2>
//                                   <p>The duration of the Agriculture Infrastructure Fund scheme shall be from the current financial year to the Financial year 2029 (10 years).</p>
//                                   <p>Financial Assistance under Agriculture Infrastructure Fund (AIF)</p>
//                                   <p>Under the scheme, banks and financial institutions will provide Rs. 1 Lakh Crore as loans with interest subvention of 3% per annum and credit guarantee coverage under CGTMSE scheme for loans up to Rs. 2 Crore.</p>

//                                   <h2>Interest Subvention Cost</h2>
//                                   <p>All loans under AIF will have an interest subvention of 3% per annum up to a limit of Rs. 2 crores.</p>
//                                   <p>This subvention will be available for a maximum period of 7 years. In the case of loans beyond Rs.2 crore, then interest subvention will be limited up to 2 crores.</p>
//                                   <p>The loans will be disbursed in four years starting with the sanction of Rs. 10,000 crores in the current financial year and Rs. 30,000 crore each in the next three fiscal years.</p>
//                                   <p>The extent and percentage of funding to private entrepreneurs out of the total financing facility may be fixed by the National Monitoring Committee.</p>
                                  
//                                   <h2>Credit Guarantee Cost</h2>
//                                   <p>Credit guarantee coverage will be available for eligible borrowers from the Agriculture Infrastructure Fund (AIF) under Credit Guarantee Fund Trust for Micro and Small Enterprises (CGTMSE) scheme for a loan up to Rs. 2 crores. The Government will pay the fee for AIF coverage</p>

//                                   <h2>Moratorium for Repayment</h2>
//                                   <p>The moratorium for repayment under this AIF may vary subject to a minimum of 6 months and a maximum of 2 years.</p>

//                                   <h2>Eligible Projects</h2>
//                                   <p>The scheme will facilitate setting up and modernization of key elements of the following projects:</p>

//                                   <ul>
//                                       <li>Post-Harvest Management Projects</li>
//                                       <li>Viable projects for building community farming assets</li>
//                                   </ul>

//                                   <img src={aif1} alt="AIF" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={aif2} alt="AIF" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={aif3} alt="AIF" className="img-fluid b-block mx-auto mb-3" />
                                  
//                                   <h2>Criteria for selection of Eligible Borrower</h2>
//                                   <p>Lending institutions will decide criteria for selection of eligible borrower in consultation with National Bank for Agriculture & Rural Development and monitoring committees:</p>
//                                  <p>All scheduled commercial banks scheduled cooperative banks, Regional Rural Banks (RRBs), Small Finance Banks, Non-Banking Financial Companies (NBFCs), and National Cooperative Development Corporation (NCDC) will provide this financing facility, after signing of Memorandum of Understanding (MoU) with NABARD.</p>
                             
//                                   <h2>AIF specific focus</h2>
//                                   <p>As part of this scheme, the Government will give specific focus to SC/ST entrepreneurs and women entrepreneurs. 24% of total grants – in – aid under the scheme should be utilized for SC/ST entrepreneurs (16% for SC and 8% for ST). Besides this, lending institutions will ensure adequate coverage of entrepreneurs belonging to women and other weaker segments of society. It has to be ensured that the benefits of the scheme are inclusive and accrue to the intended beneficiaries.</p>

//                                   <h2>Management of AIF</h2>
//                                   <p>Agri Infra fund will be managed and monitored through an online Management Information System (MIS) platform. Using this portal, all qualified entities can apply for loans under the fund. The platform will provide benefits such as transparency of interest rates offered by multiple banks, scheme details including interest subvention and credit guarantee offered, minimum documentation, faster approval process as also integration with other scheme benefits.</p>
                              
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// };


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function AIF() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col>
              <h1>
                Agriculture Infrastructure Fund (AIF)
              </h1>

              <p>
                The Agriculture Infrastructure Fund (AIF) is a Government of India
                initiative providing financing support for building post-harvest
                infrastructure and community farming assets.
              </p>

              <p>
                It helps farmers and agri-businesses access affordable credit,
                reduce losses, and improve income through better infrastructure.
              </p>
            </Col>

            {/* RIGHT FORM */}
            {/* <Col lg={4}>
              <div className="p-4 shadow rounded right-form">
                <Form>
                  <Form.Control className="mb-3" placeholder="Name" />
                  <Form.Control className="mb-3" placeholder="Email" />
                  <Form.Control className="mb-3" placeholder="Phone" />
                  <Form.Control className="mb-3" placeholder="Subject" />
                  <Button className="w-100">Get Started</Button>
                </Form>
              </div>
            </Col> */}

          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Key Objective
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strengthen agricultural infrastructure</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Improve supply chain efficiency</li>
            <li><FaCheckCircle /> Enhance farmer income</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Can Benefit
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Farmers & FPOs</li>
            <li><FaCheckCircle /> Agri-entrepreneurs & startups</li>
            <li><FaCheckCircle /> SHGs & cooperative societies</li>
            <li><FaCheckCircle /> PACS & JLG groups</li>
            <li><FaCheckCircle /> PPP projects</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Key Advantages
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Better storage and logistics</li>
            <li><FaCheckCircle /> Reduced wastage</li>
            <li><FaCheckCircle /> Improved market access</li>
            <li><FaCheckCircle /> Technology adoption (AI, IoT)</li>
            <li><FaCheckCircle /> Increased farmer income</li>
          </ul>

          {/* FINANCIAL SUPPORT */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Loans via banks & financial institutions</li>
            <li><FaCheckCircle /> 3% interest subsidy</li>
            <li><FaCheckCircle /> Credit guarantee (CGTMSE)</li>
            <li><FaCheckCircle /> Loans up to ₹2 crore</li>
          </ul>

          {/* REPAYMENT */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Repayment & Duration
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Scheme duration: 10 years</li>
            <li><FaCheckCircle /> Moratorium: 6 months to 2 years</li>
            <li><FaCheckCircle /> Flexible repayment options</li>
          </ul>

          {/* PROJECTS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Eligible Projects
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Warehouses & cold storage</li>
            <li><FaCheckCircle /> Supply chain & logistics</li>
            <li><FaCheckCircle /> Food processing units</li>
            <li><FaCheckCircle /> Packaging & grading units</li>
            <li><FaCheckCircle /> Smart agriculture infrastructure</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including project
            report preparation, loan processing, documentation, and subsidy
            assistance to ensure smooth approvals.
          </p>

          {/* WHY CHOOSE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Expert financial & subsidy guidance</li>
            <li><FaCheckCircle /> End-to-end support</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Customized project solutions</li>
            <li><FaCheckCircle /> Compliance & documentation support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}

